import {
  PageWizardProvider,
  PageWizardRoutes,
} from "shared/components/layout/PageWizard";

export const AllocationSetupPage: React.FC = () => (
  <PageWizardProvider allowNavigate={true}>
    <PageWizardRoutes />
  </PageWizardProvider>
);
